import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loading } from "@/components/Loading/Loading";

export const Integrate = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get("code");
  const navigate = useNavigate();

  if (code != null && code != "") {
    localStorage.setItem("funnel-code", code);
  }

  useEffect(() => {
    navigate("/");
  }, [navigate]);

  return (
    <div>
      <Loading />
    </div>
  );
};
